<template>
    <span>
        <el-select v-model="selectValue" placeholder="请选择">
        <el-option
                v-for="item in fileCategorys"
                :key="item.code"
                :label="item.name"
                :value="item.code">
        </el-option>
    </el-select>
        <input v-model="value" style="display: none"></input>
    </span>
</template>

<script>
    export default {
        name: "FileCatrgorySelect",
        props:{
            value: {
                type: Array,
                default:function () {
                    return [] ;
                }
            }
        },
        watch:{
            value:{
              deep:true,
              handler:function () {
                  this.selectValue = this.value;
              }
            },
            selectValue:{
                deep:true,
                handler:function () {
                    this.$emit('input',this.selectValue);
                }
            }
        },
        data(){
            return {
                fileCategorys:[],
                selectValue:[],
            }
        },
        created() {

            let vm = this;

            vm.$http.post(vm.$api.fileCategory.list,vm.$qs.stringify({onPage:false})).then((resp)=>{
                    vm.fileCategorys = resp.data.data.fileCategorys;
            });

        }
    }
</script>

<style scoped>

</style>